import { render, staticRenderFns } from "./ReFilter.vue?vue&type=template&id=521aa8a2"
import script from "./ReFilter.vue?vue&type=script&lang=ts"
export * from "./ReFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports